import { render, staticRenderFns } from "./productDelete.vue?vue&type=template&id=1079e549&"
import script from "./productDelete.vue?vue&type=script&lang=js&"
export * from "./productDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports